export const formatDayStrForYMDHMS = 'YYYY-MM-DD HH:mm:ss';

export const formatDayStrForYMD = 'YYYY-MM-DD';